import React from 'react';
import DashboardLayout from '../../layouts/DashboardLayout';
import { useAuth } from '../../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Settings, User, Mail, Shield } from 'lucide-react';

const SettingsPage = () => {
  const { user, school } = useAuth();

  return (
    <DashboardLayout>
      <div className="space-y-6 animate-fade-in max-w-2xl">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Settings</h1>
          <p className="text-slate-500">Application settings and information</p>
        </div>

        {/* Account Info */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <User className="h-5 w-5" />
              Account Information
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center gap-4 p-4 rounded-lg bg-slate-50 dark:bg-slate-800">
              <div className="h-12 w-12 rounded-full bg-indigo-100 dark:bg-indigo-900 flex items-center justify-center">
                <User className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
              </div>
              <div>
                <p className="font-medium text-slate-900 dark:text-white">{user?.name}</p>
                <p className="text-sm text-slate-500 capitalize">{user?.role}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 text-sm">
              <Mail className="h-4 w-4 text-slate-400" />
              <span className="text-slate-600 dark:text-slate-300">{user?.email}</span>
            </div>
            <div className="flex items-center gap-3 text-sm">
              <Shield className="h-4 w-4 text-slate-400" />
              <span className="text-slate-600 dark:text-slate-300 capitalize">{user?.role} Access</span>
            </div>
          </CardContent>
        </Card>

        {/* Application Info */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Settings className="h-5 w-5" />
              Application Information
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-slate-800">
              <span className="text-slate-500">Application</span>
              <span className="font-medium text-slate-900 dark:text-white">English VocaLab</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-slate-800">
              <span className="text-slate-500">Version</span>
              <span className="font-medium text-slate-900 dark:text-white">1.0.0</span>
            </div>
            <div className="flex justify-between py-2 border-b border-slate-100 dark:border-slate-800">
              <span className="text-slate-500">School</span>
              <span className="font-medium text-slate-900 dark:text-white">{school?.name || '-'}</span>
            </div>
            <div className="flex justify-between py-2">
              <span className="text-slate-500">License Status</span>
              <span className={`font-medium ${school?.license_active ? 'text-emerald-600' : school?.trial_active ? 'text-amber-600' : 'text-rose-600'}`}>
                {school?.license_active ? 'Licensed' : school?.trial_active ? 'Trial' : 'Expired'}
              </span>
            </div>
          </CardContent>
        </Card>

        {/* About */}
        <Card>
          <CardHeader>
            <CardTitle>About English VocaLab</CardTitle>
            <CardDescription>
              Powered by AI technology
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
              English VocaLab is an interactive language learning platform designed for schools. 
              It provides three powerful lab modules: Text-to-Speech, Speech-to-Text, and Multiple Choice Questions (MCQ). 
              The platform supports both offline (local network) and online deployment modes.
            </p>
            <p className="text-xs text-slate-400 mt-4">
              © 2024 English VocaLab. All rights reserved.
            </p>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default SettingsPage;
